import { useState, useCallback, useEffect } from 'react';
import shallow from 'zustand/shallow';
import { packageApi } from '@api';
import { usePackagesState } from '@root/state';
import { IState } from '@root/state/packages';
import { IGetPackagesProp } from '@root/api/package';

interface IValue extends IState {
  getPackages: (v: IGetPackagesProp, packageId: string) => void;
}

const usePackages = (): IValue => {
  const {
    loading,
    updateTime,
    packages,
    packageId,
    selectedPackage,
    setLoading,
    setPackages,
    setSelectedPackage,
    resetSelectedData,
    resetInitData,
  } = usePackagesState(
    (state) => ({
      loading: state.loading,
      updateTime: state.updateTime,
      packages: state.packages,
      packageId: state.packageId,
      selectedPackage: state.selectedPackage,
      setLoading: state.setLoading,
      setSelectedPackage: state.setSelectedPackage,
      setPackages: state.setPackages,
      resetSelectedData: state.resetSelectedData,
      resetInitData: state.resetInitData,
    }),
    shallow,
  );

  const getPackages = useCallback(
    (data: IGetPackagesProp, packageId: string) => {
      setLoading(0);

      packageApi
        .getPackages(data)
        .then((data: any) => {
          setPackages(data.list || [], packageId);
          setLoading(1);
        })
        .catch(() => {
          setLoading(2);
        });
    },
    [setLoading, setPackages],
  );

  return {
    packages,
    packageId,
    loading,
    updateTime,
    selectedPackage,
    setPackages,
    setSelectedPackage,
    resetSelectedData,
    getPackages,
    resetInitData,
    setLoading,
  };
};

export default usePackages;
